import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { VisitTypeInput, medicalVisitTypesApi } from '../visit-types';

export const visitTypeKeys = {
  all: ['medical', 'visit-types'] as const,
  list: () => [...visitTypeKeys.all] as const,
};

export function useVisitTypesQuery() {
  return useQuery({
    queryKey: visitTypeKeys.list(),
    queryFn: () => medicalVisitTypesApi.list(),
  });
}

export function useCreateVisitTypeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: VisitTypeInput) => medicalVisitTypesApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: visitTypeKeys.list() }),
  });
}

export function useUpdateVisitTypeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<VisitTypeInput> }) => medicalVisitTypesApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: visitTypeKeys.list() }),
  });
}

export function useDeleteVisitTypeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => medicalVisitTypesApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: visitTypeKeys.list() }),
  });
}
